import { Component, Input } from '@angular/core';

import { RouterLink } from '@angular/router';

interface Title {
  label: string;
  url?: string;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './breadcrumb.html',
  styleUrls: ['./breadcrumb.scss'],
})
export class BreadcrumbComponent {
  @Input() titles: Title[] = [];
}
